var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanLogo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.11,51.5h-8.21c-9.33,0-16.9,7.26-16.9,16.21v24.79h42v-24.79c0-8.95-7.56-16.21-16.9-16.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,44.5c9.16,0,16.71-6.85,17.84-15.71l-10.41-2.77c-1.14-.11-2.06-.96-2.23-2.11l-.38-2.5-4.75,4.03c-.45.38-1.02.59-1.62.59h-16.41c0,.16-.02.31-.02.47,0,9.94,8.06,18,18,18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.55,18.55c.69-.58,1.65-.75,2.49-.43.85.32,1.46,1.07,1.6,1.96l.46,3.03,9.86,2.62c-.41-9.58-8.28-17.22-17.96-17.22-8.75,0-16.04,6.25-17.66,14.53h15.91l5.3-4.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanLogo3);
export default __webpack_public_path__ + "static/media/human_logo_3.1d3c970a5a25170954d070e1984f0812.svg";
export { ForwardRef as ReactComponent };